import CUSTOM_SECTION_TYPE from '@src/quince-site-common/src/domains/CustomSectionType'
import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'
import { useTrackIsElementVisible } from '@src/quince-site-common/src/hooks/useTrackIsElementVisible'
import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'
import ProductPageSectionProps from '@src/quince-site-pdp/src/domains/ProductPageSectionProps'
import { FeatureSection7Landing } from '@src/SectionRenderer/sections/featureSection7Landing'
import { FeatureSection7LandingNew } from '@src/SectionRenderer/sections/featureSection7LandingNew'
import { useCallback } from 'react'

function ProductComparisonSection(props: ProductPageSectionProps | BundlePageSectionProps) {
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  const product = 'bundle' in props ? props.bundle : props.product

  const sections = isMobile ? product.mobileSections : product.desktopSections

  const fcSection = sections.find(ds => ds.sectionType === CUSTOM_SECTION_TYPE.FEATURE_SECTION_7)
  const fcSectionNew = sections.find(ds => ds.sectionType === CUSTOM_SECTION_TYPE.FEATURE_SECTION_7_NEW)

  const getIsVisibleTrackParams = useCallback(() => {
    const productId = product.id
    return {
      // @i18n-ignore
      action: 'product_comparison_section',
      value: true,
      context: {
        productId,
      },
    }
  }, [product.id])

  const { ref: trackIsVisibleRef } = useTrackIsElementVisible(getIsVisibleTrackParams)

  return (
    <div ref={trackIsVisibleRef}>
      {fcSection && <FeatureSection7Landing sectionConfig={fcSection} product={product} />}
      {fcSectionNew && <FeatureSection7LandingNew sectionConfig={fcSectionNew} />}
    </div>
  )
}

export default ProductComparisonSection
